import { Model } from '@vuex-orm/core'
import { Lesson, Course } from 'src/store/models/timetable/index.js'

import fetchBySchool from './cacheHelper.js'
import Timetable from 'src/api/timetable.js'
import courseCreation from 'src/mixins/timetable/courseCreation.js'
import { i18n } from 'src/config/i18n.ts'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export class CRUD extends Model {
  async $createAndPush ({ waitForServer } = { waitForServer: false }) {
    return this.constructor.createAndPush(this, { waitForServer })
  }

  async $updateAndPush () {
    return this.constructor.updateAndPush(this)
  }

  async $deleteAndPush ({ waitForServer } = { waitForServer: false }) {
    return this.constructor.deleteAndPush(this, { waitForServer })
  }

  static async createAndPush (el, { waitForServer } = { waitForServer: false }) {
    const entity = new el.constructor({ ...el, id: el.id || GlobalPrototypes.uuid() })

    this.validateCourseEntity(entity)

    waitForServer ? await this.pushEntity(entity) : this.pushEntity(entity)
    return this.insert({ data: entity })
  }

  static async updateAndPush (el) {
    const promises = this.relations && this.relations.map(({ entity, key }) => entity.delete(en => en[key] === el.id))

    this.validateCourseEntity(el)

    await Promise.all(promises || [])
    this.pushEntity(el)
    return this.insertOrUpdate({ data: el })
  }

  static async deleteAndPush (el, { waitForServer } = { waitForServer: false }) {
    waitForServer ? await this.deleteEntity(el) : this.deleteEntity(el)
    return this.delete(el.id)
  }

  static async fetchBySchool (model = this, url = this.fetchUrl, primaryKey = 'id') {
    return fetchBySchool(model, url, primaryKey)
  }

  static pushEntity (el) {
    console.log({ el })
    const entity = el instanceof Lesson ? this.modifyLesson(el) : el
    return Timetable.postTimetableEditorPushEntity(this.entity, entity, { headers: this.store().state.timetablePlanner.headers })
  }

  static deleteEntity (el) {
    return Timetable.postTimetableEditorPopEntity(this.entity, el, { headers: this.store().state.timetablePlanner.headers })
  }

  static modifyLesson (lesson) {
    return {
      ...lesson,
      teachers: [],
      bookables: [],
      grades: [],
      ...['teacher', 'grade', 'bookable'].reduce((acc, key) => ({
        ...acc,
        [`${key}s_pivot`]: lesson[`${key}s`].map(s => ({ [`${key}_id`]: s.id, lesson_id: lesson.id }))
      }), {})

    }
  }

  // validates course entity if it already exists
  static validateCourseEntity (entity) {
    if (entity instanceof Course && courseCreation.methods.courseAlreadyExists(entity)) {
      GlobalPrototypes.toastNotify({
        type: 'error',
        text: i18n.global.t('management.timetable_popover.duplicated_course_warning')
      })
      throw new Error('Course already exists')
    }
  }
}

export default CRUD
